/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-10-15 08:35:42
 * Modified By: Val Liu
 * -----
 */

import { StringHelper } from "../utilities";
import {
    BaseUITag,
    EUITagRuleType,
    EUITagRuleUnion,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    UITag,
} from "./core";
import { lang } from "@root/core/i18n";

// @uiLabel - attach `label` to form element or table header.

@UITag.set({ default: true })
export class uiLabel extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.TableHeaderCell, EUITagTarget.FormElement];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.String];
    allowNullRule: boolean = true; /// default: auto detect i18n

    /// set props :label
    parse(input: IUITagInput): IUITagResult | null {
        const rule = this.parseRule(input);
        /// if default, attempt use `meta.name` to do translate
        if (input.isDefault || rule == null) {
            const name = input.meta.attr.name;
            const cap = StringHelper.capitalize(name);
            let rtn = ["w_"].reduce<string | null>((final, value) => {
                if (final != null) return final;
                const key = `${value}${cap}`;
                if (lang.keyExists(key)) {
                    return lang.translate(key as any);
                }
                return final;
            }, null);
            if (rtn == null) rtn = name;
            return {
                props: { label: rtn },
            };
        }

        /// normal case
        return {
            props: { label: lang.translate(rule as string) },
        };
    }
}
